import type { MRT_Row } from '@talentmesh/table';
import MemberManagementButton from './MemberManagementButton';
import { TeamMember } from '@/Models/TeamMember';

export interface TeamMemberActionsCellProps {
    row: MRT_Row<TeamMember>;
}

function TeamMemberActionsCell({ row }: TeamMemberActionsCellProps) {
    if (row.original.role === 'Owner') {
        return null;
    }
    return <MemberManagementButton row={row} />;
}

export default TeamMemberActionsCell;
